export default __webpack_public_path__ + "static/media/yellowfolder.650d737a.svg";